import { Text } from '@chakra-ui/react';

interface Props {
  maxLength: number;
  value: string;
}

export const WordsLeftCounter: React.FC<Props> = ({
  maxLength,
  value = '',
  ...props
}) => {
  return (
    <Text color="primary.300" fontSize="xs" {...props}>
      Max. {maxLength} characters.
      {value.length !== 0 ? ` ${maxLength - value.length} characters left` : ''}
    </Text>
  );
};
